import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsProvider","useAnalytics"] */ "/app/src/core/analytics/hooks/useAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogProvider"] */ "/app/src/core/analytics/hooks/useDatadog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RemoteConfigProvider","useRemoteConfig"] */ "/app/src/core/config/hooks/useRemoteConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirebaseProvider","useFirebase"] */ "/app/src/core/firebase/hooks/useFirebase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/src/core/query/hooks/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSafeInfiniteQuery"] */ "/app/src/core/query/hooks/useSafeInfiniteQuery.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useSafeMutation"] */ "/app/src/core/query/hooks/useSafeMutation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useSafeQuery","SafeQueryError"] */ "/app/src/core/query/hooks/useSafeQuery.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider","useAuth"] */ "/app/src/features/auth/hooks/useAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalDialog"] */ "/app/src/shared/components/GlobalDialog/GlobalDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyboardDismissProvider"] */ "/app/src/shared/hooks/useKeyboardDismiss.tsx");
